import { Accordion, AccordionDetails, AccordionSummary, Box, Button, MenuItem, Select, TextField, Typography } from "@mui/material";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Controller, useForm } from "react-hook-form";
import { useState } from "react";
import { IInscricaoEtapa } from "shared/features/api/inscricao/types";
import { useAvaliarEtapaMutation } from "shared/features/api/avaliacao/avaliacaoSlice";
import { toast } from "react-toastify";

interface Props {
  etapa: IInscricaoEtapa;
  idInscricao: number;
}

interface FormInputs {
  nota: string;
  observacao: string;
  status: string;
}

export const AvaliacaoGenericaAccordion: React.FC<Props> = ({ etapa, idInscricao }) => {
  const [avaliar, {isLoading}] = useAvaliarEtapaMutation();

  const [modoEdicao, setModoEdicao] = useState(false);
  const { control, handleSubmit, reset } = useForm<FormInputs>({
    defaultValues: {
      nota: etapa.nota?.toString() || "",
      observacao: etapa.observacao || "",
      status: etapa.statusEtapa || "ANDAMENTO",
    },
  });

  const handleAvaliar = async (data: FormInputs) => {
    const payloadEditarAvaliacao = {
      idInscricao: idInscricao,
      idEtapa: etapa.idEtapa,
      body: {
        nota: Number(data.nota),
        observacao: data.observacao,
        aprovado: data.status === "APROVADO",
      },
    };

    await toast.promise(
        avaliar(payloadEditarAvaliacao).unwrap(),
        {
          pending: "Salvando avaliação...",
          success: "Avaliação atualizada!",
          error: "Erro ao salvar avaliação",
        }
      );

      reset({
        nota: data.nota,
        observacao: data.observacao,
        status: data.status,
      });
      setModoEdicao(false);
  };

  return (
    <Accordion sx={{ boxShadow: 2 }}>
      <AccordionSummary
        expandIcon={<ArrowDropDownIcon />}
        aria-controls={`panel${etapa.idEtapa}-content`}
        id={`panel${etapa.idEtapa}-header`}
        sx={{ borderBottom: "1px solid #d3d3d3" }}
      >
        <Typography variant="caption" color="#040C2C" fontSize={16}>
          {etapa.nomeEtapa}: {etapa.statusEtapa.toLowerCase().replace("_", " ")}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        {modoEdicao ? (
          <Box
            component="form"
            onSubmit={handleSubmit(handleAvaliar)}
            display="flex"
            flexDirection="column"
            gap={2}
          >
            <Controller
              name="nota"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Nota"
                  size="small"
                  type="number"
                />
              )}
            />
            <Controller
              name="observacao"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Observação"
                  multiline
                  minRows={3}
                />
              )}
            />
            <Controller
              name="status"
              control={control}
              render={({ field }) => (
                <Select {...field} size="small">
                  <MenuItem value="ANDAMENTO">Em andamento</MenuItem>
                  <MenuItem value="ANDAMENTO">Finalizado</MenuItem>
                  <MenuItem value="APROVADO">Aprovado</MenuItem>
                  <MenuItem value="REPROVADO">Reprovado</MenuItem>
                </Select>
              )}
            />

            <Box display="flex" justifyContent="flex-end" gap={1}>
              <Button
                variant="outlined"
                onClick={() => setModoEdicao(false)}
              >
                Cancelar
              </Button>
              <Button type="submit" variant="contained">
                Salvar
              </Button>
            </Box>
          </Box>
        ) : (
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography>
              {etapa.observacao || "Sem observações"}
            </Typography>
            <Button variant="outlined" onClick={() => setModoEdicao(true)}>
              {etapa.statusEtapa !== "ANDAMENTO" &&
              etapa.statusEtapa !== "AGUARDANDO"
                ? "Editar"
                : "Avaliar"}
            </Button>
          </Box>
        )}
      </AccordionDetails>
    </Accordion>
  );
};
